<div class="dropdown inline-block relative" (clickOutside)="onClickedOutsideLang($event)">
  <button (click)="langDropdownOpen = !langDropdownOpen"
          class="btn btn-icon rounded-full bg-violet-600/5 hover:bg-violet-600 border-violet-600/10 hover:border-violet-600 text-violet-600 hover:text-white">
    {{ iconLanguage }}
  </button>
  <div *ngIf="langDropdownOpen"
       class="dropdown-content absolute right-0 mt-2 bg-white dark:bg-slate-900 shadow dark:shadow-gray-800 rounded-md overflow-hidden z-10"
       style="min-width: 10rem;">
    <a *ngFor="let lang of getAvailableLanguages()" (click)="switchLanguage(lang.id)"
      class="block py-2 px-4 text-sm hover:bg-gray-100 dark:hover:bg-slate-800 cursor-pointer"
      [ngClass]="{'bg-gray-100 dark:bg-slate-800': currentLang === lang.id}"
      [ngStyle]="{'font-weight': currentLang === lang.id ? 'bold' : 'normal'}">
      {{ lang.name }}
    </a>
  </div>
</div>
